<template>
  <v-container fluid>
    <!-- 定期配送登録ダイアログ { -->
    <v-card v-if="!displayConfirmDialog && !displayCompletedDialog" flat>
      <Form v-if="wordListLoaded" v-slot="{ meta }">
        <v-card flat>
          <!-- 登録タイトル -->
          <v-card-title
            v-if="!updateMode && !deleteMode"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_regular_delivery_Request_regist }}
          </v-card-title>
          <!-- 変更タイトル -->
          <v-card-title
            v-else-if="updateMode"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_regular_delivery_Request_edit }}
          </v-card-title>
          <v-card-text>
            <v-card flat class="pl-5 pt-3">
              <v-row dense class="mb-3">
                <!-- 配達元 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_delivery_source }}
                  </v-row>
                </v-col>
                <v-col cols="3">
                  {{
                    shopData !== null && shopData !== undefined
                      ? shopData.name
                      : ""
                  }}
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 配達先住所 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_delivery_destination_address }}
                  </v-row>
                </v-col>
                <v-col cols="9">
                  {{ regularDeliveryCreateInput.delivery_zip_code ? "〒" : "" }}
                  {{
                    regularDeliveryCreateInput.delivery_zip_code.substring(0, 3)
                  }}
                  {{ regularDeliveryCreateInput.delivery_zip_code ? "-" : "" }}
                  {{
                    regularDeliveryCreateInput.delivery_zip_code.substring(3)
                  }}
                  {{ regularDeliveryCreateInput.delivery_address1 }}
                </v-col>
              </v-row>
              <!-- 住所選択ボタン -->
              <v-row dense class="mb-3">
                <v-col cols="3"></v-col>
                <v-col cols="3"
                  ><v-btn
                    size="small"
                    color="primary"
                    variant="outlined"
                    @click="onClickAddressUpdate"
                    >{{ wordList.btn_area_select }}</v-btn
                  ></v-col
                >
              </v-row>
              <v-row
                v-if="
                  blockList !== null &&
                  blockList !== undefined &&
                  blockList.length !== 0 &&
                  zip_code.length !== 0 &&
                  user_id.length === 0 &&
                  !areaDialog
                "
                dense
                  class="mb-3"
              >
                <!-- 丁目 -->
                <v-col cols="12" sm="4" md="4" lg="4"></v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="py-2">
                  <v-card border class="px-5 py-2" style="border-width: 2px">
                    <span
                      v-for="(value, key) in blockList"
                      :key="key"
                      class="mx-3 text-blue text-decoration-underline"
                      style="cursor: pointer"
                      @click="onClickAddressBlockLink(value!)"
                    >
                      {{ value }}
                    </span>
                  </v-card>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 配達先住所(番地) -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_destination_address_detail }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_destination_address_detail"
                    rules="required|max:100"
                    v-model="regularDeliveryCreateInput.delivery_address2"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_address2"
                      :placeholder="
                        wordList.plc_delivery_destination_address_detail
                      "
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="handleBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 建物名 部屋番号 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                    wordList.lbl_room_num
                  }}</v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_room_num"
                    rules="max:100"
                    v-model="regularDeliveryCreateInput.delivery_address3"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_address3"
                      :placeholder="wordList.plc_room_num"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <!-- お届け便選択 -->
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_delivery_id }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="2" class="delivery-week-select">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_week"
                    rules="required"
                    v-model="deliveryIdSelectValues"
                  >
                    <v-autocomplete
                      v-model="deliveryIdSelectValues"
                      density="compact"
                      :items="deliveryIdItems"
                      item-title="label"
                      item-value="value"
                      :clearable="true"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      multiple
                      variant="outlined"
                      return-object
                      :menu-props="{
                        maxHeight: 410,
                        height: 410,
                      }"
                      @blur="handleBlur"
                      @update:model-value="onChangeDeliveryIdSelect"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_id"
                    rules="required"
                    v-model="deliverySelectValues"
                  >
                    <v-autocomplete
                      v-model="deliverySelectValues"
                      density="compact"
                      :items="listDeliveryId"
                      item-title="delivery_name"
                      item-value="area_delivery_id"
                      :label="wordList.lbl_delivery_id"
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      @blur="handleBlur"
                      @update:model-value="onChangeDeliveryId"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達時間 -->
              <v-row v-if="delivery_time_input" dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_delivery_time }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="1">
                  <Field
                    v-slot="{ componentField, errors }"
                    v-model="
                      regularDeliveryCreateInput.irregular_delivery_start_time
                    "
                    :name="wordList.lbl_irregular_delivery_start_time"
                    rules="required|time_format"
                  >
                    <v-text-field
                      v-bind="componentField"
                      density="compact"
                      variant="outlined"
                      :label="wordList.lbl_irregular_delivery_start_time"
                      :placeholder="wordList.plc_irregular_delivery_time"
                      :error-messages="errors"
                      @change="onChangeDeliveryStartTime"
                    ></v-text-field>
                  </Field>
                </v-col>
                <p class="mt-3 mx-2 center">～</p>
                <v-col cols="1">
                  <Field
                    v-slot="{ componentField, errors }"
                    v-model="
                      regularDeliveryCreateInput.irregular_delivery_end_time
                    "
                    :name="wordList.lbl_irregular_delivery_end_time"
                    rules="required|time_format"
                  >
                    <v-text-field
                      v-bind="componentField"
                      density="compact"
                      variant="outlined"
                      :label="wordList.lbl_irregular_delivery_end_time"
                      :placeholder="wordList.plc_irregular_delivery_time"
                      :error-messages="errors"
                      @change="onChangeDeliveryEndTime"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row v-if="!delivery_time_input" dense class="mb-3">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_delivery_time }}
                  </v-row>
                </v-col>
                <v-col cols="3">
                  {{ regularDeliveryCreateInput.irregular_delivery_start_time }}
                  ～
                  {{ regularDeliveryCreateInput.irregular_delivery_end_time }}
                </v-col>
              </v-row>
              <!-- お名前(漢字) -->
              <v-row dense class="mb-3">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kanji }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    name="delivery_name1"
                    :label="wordList.lbl_name_kanji"
                    rules="required|max:100"
                    v-model="regularDeliveryCreateInput.delivery_name1"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_name1"
                      :placeholder="wordList.plc_family_name_kanji"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="handleBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    name="delivery_name2"
                    :label="wordList.lbl_name_kanji"
                    rules="required|max:100"
                    v-model="regularDeliveryCreateInput.delivery_name2"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_name2"
                      :placeholder="wordList.plc_first_name_kanji"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="handleBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- お名前(かな) -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                    >{{ wordList.lbl_name_kana }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    name="delivery_name_kana1"
                    :label="wordList.lbl_name_kana"
                    rules="required|max:100|regex:^[ぁ-んー]+$"
                    v-model="regularDeliveryCreateInput.delivery_name_kana1"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_name_kana1"
                      :placeholder="wordList.plc_family_name_kana"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="handleBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    name="delivery_name_kana2"
                    :label="wordList.lbl_name_kana"
                    rules="required|max:100|regex:^[ぁ-んー]+$"
                    v-model="regularDeliveryCreateInput.delivery_name_kana2"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_name_kana2"
                      :placeholder="wordList.plc_first_name_kana"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="handleBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 電話番号 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_tel }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_tel"
                    rules="required|numeric|min:10|max:11"
                    v-model="regularDeliveryCreateInput.delivery_phone"
                  >
                    <v-text-field
                      v-model="regularDeliveryCreateInput.delivery_phone"
                      :placeholder="wordList.plc_tel"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="handleBlur"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 決済方法 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_pay_method }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="4" lg="4">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_pay_method"
                    rules="required"
                    v-model="regularDeliveryCreateInput.payment_method"
                  >
                    <v-autocomplete
                      v-model="regularDeliveryCreateInput.payment_method"
                      density="compact"
                      :items="paymentMethodItems"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      :disabled="paymentMethodItems.length == 1"
                      variant="outlined"
                      return-object
                      @blur="handleBlur"
                      @update:model-value="
                        onChangePaymentMethod(
                          regularDeliveryCreateInput.payment_method
                        )
                      "
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 支払金額 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center"
                    v-if="paymentRequiredFlg"
                    dense
                      class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                    <ImportantChip></ImportantChip
                  ></v-row>
                  <v-row align="center"
                    v-if="!paymentRequiredFlg"
                    dense
                      class="form-label-row mr-15 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                  </v-row>
                </v-col>
                <v-col cols="6" sm="4" md="4" lg="4">
                  <Field
                    v-if="paymentRequiredFlg"
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_pay_money"
                    rules="required|max:11"
                    v-model="dummy_payment_amount"
                  >
                    <v-text-field
                      v-model="dummy_payment_amount"
                      class="text-right"
                      :placeholder="wordList.plc_pay_money"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @focus="onFocus(dummy_payment_amount)"
                      @blur="onBlur(dummy_payment_amount); handleBlur();"
                    >
                    </v-text-field>
                  </Field>
                  <Field
                    v-if="!paymentRequiredFlg"
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_pay_money"
                    rules="max:11"
                    v-model="dummy_payment_amount"
                  >
                    <v-text-field
                      v-model="dummy_payment_amount"
                      class="text-right"
                      :placeholder="wordList.plc_pay_money"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @focus="onFocus(dummy_payment_amount)"
                      @blur="onBlur(dummy_payment_amount); handleBlur();"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
                <span class="mt-3">{{ wordList.lbl_yen }}</span>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 個口数 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                    >{{ wordList.lbl_unit_number
                    }}<ImportantChip></ImportantChip
                  ></v-row>
                </v-col>
                <v-col cols="6" sm="2" md="2" lg="2">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_unit_number"
                    rules="required|min:1"
                    v-model="regularDeliveryCreateInput.unit"
                  >
                    <v-autocomplete
                      v-model="regularDeliveryCreateInput.unit"
                      :items="unitItems"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      density="compact"
                      variant="outlined"
                      return-object
                      :error-messages="errors"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <v-row v-if="house_card_display == 1" dense class="mb-3">
                <!-- ハウスカード番号 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center"
                    v-if="house_card_required == 1"
                    dense
                      class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_house_card }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center" v-else dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_house_card }}
                  </v-row>
                </v-col>
                <v-col cols="6" sm="4" md="4" lg="4">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_house_card"
                    :rules="house_card_validation"
                    v-model="regularDeliveryCreateInput.house_card"
                  >
                    <v-text-field
                      v-if="house_card_required == 1"
                      v-model="regularDeliveryCreateInput.house_card"
                      :placeholder="wordList.plc_house_card"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      persistent-hint
                      @blur="handleBlur"
                      @change="onChangeHouseCard()"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="regularDeliveryCreateInput.house_card"
                      :placeholder="wordList.plc_house_card"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      persistent-hint
                      @blur="handleBlur"
                      @change="onChangeHouseCard()"
                    ></v-text-field>
                  </Field>
                  <p></p>
                </v-col>
              </v-row>
              <v-row dense class="mb-3">
                <!-- 会員備考 -->
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
                    wordList.lbl_memo_member
                  }}</v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field v-slot="{ errors }" :name="wordList.lbl_memo_member">
                    <v-textarea
                      v-model="regularDeliveryCreateInput.member_notes"
                      :placeholder="wordList.plc_memo_member"
                      variant="outlined"
                      :error-messages="errors"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達依頼作成日時 -->
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_delivery_request_create }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col class="flex-grow-0" style="flex: 0 0 12.5%; max-width: 12.5%;">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_request_create_date"
                    rules="required"
                    v-model="deliveryRequestCreateDateValues"
                  >
                    <v-autocomplete
                      v-model="deliveryRequestCreateDateValues"
                      density="compact"
                      :items="deliveryRequestCreateDateItem"
                      item-title="label"
                      item-value="delivery_request_create_date"
                      :label="wordList.lbl_delivery_request_create_date"
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      @blur="handleBlur"
                      @update:model-value="onChangeDeliveryRequestCreateDate"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col class="flex-grow-0" style="flex: 0 0 12.5%; max-width: 12.5%;">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_request_create_time"
                    rules="required"
                    v-model="deliveryRequestCreateTimeValues"
                  >
                    <v-autocomplete
                      v-model="deliveryRequestCreateTimeValues"
                      density="compact"
                      :items="deliveryRequestCreateTimeItem"
                      item-title="delivery_request_create_time"
                      item-value="delivery_request_create_time"
                      :label="wordList.lbl_delivery_request_create_time"
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      @blur="handleBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <p class="mt-3 mx-2 center">時</p>
              </v-row>
              <!-- 定期配達有効期間 -->
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_valid_date }}
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <v-menu
                    :close-on-content-click="false"
                    :offset="[40, 0]"
                    transition="scale-transition"
                    location="bottom"
                    min-width="auto"
                  >
                    <template #activator="{ props }">
                      <Field
                        v-slot="{ errors }"
                        :name="wordList.lbl_valid_date_from"
                        rules="max:10"
                        v-model="regularDeliveryCreateInput.valid_date_from"
                      >
                        <v-text-field
                          v-model="regularDeliveryCreateInput.valid_date_from"
                          :label="wordList.lbl_valid_date_from"
                          :placeholder="wordList.plc_valid_date"
                          readonly
                          variant="outlined"
                          density="compact"
                          clearable
                          v-bind="props"
                          :error-messages="errors"
                          bg-color="#fff"
                        ></v-text-field>
                      </Field>
                    </template>
                    <v-locale-provider
                      locale="ja"
                      :messages="{ ja: vuetifyJa }"
                    >
                      <v-date-picker
                        v-datepicker-scroll
                        v-model="regularDeliveryCreateInput.valid_date_from"
                        hide-header
                        show-adjacent-months
                        view-mode="month"
                        @update:model-value="onChangeValidDateFrom"
                      ></v-date-picker>
                    </v-locale-provider>
                  </v-menu>
                </v-col>
                <p class="mt-3 mx-2 center">〜</p>
                <v-col cols="2">
                  <v-menu
                    :close-on-content-click="false"
                    :offset="[40, 0]"
                    transition="scale-transition"
                    location="bottom"
                    min-width="auto"
                  >
                    <template #activator="{ props }">
                      <Field
                        v-slot="{ errors }"
                        :name="wordList.lbl_valid_date_to"
                        rules="max:10"
                        v-model="regularDeliveryCreateInput.valid_date_to"
                      >
                        <v-text-field
                          v-model="regularDeliveryCreateInput.valid_date_to"
                          :label="wordList.lbl_valid_date_to"
                          :placeholder="wordList.plc_valid_date"
                          readonly
                          variant="outlined"
                          density="compact"
                          clearable
                          v-bind="props"
                          :error-messages="errors"
                          bg-color="#fff"
                        ></v-text-field>
                      </Field>
                    </template>
                    <v-locale-provider
                      locale="ja"
                      :messages="{ ja: vuetifyJa }"
                    >
                      <v-date-picker
                        v-datepicker-scroll
                        v-model="regularDeliveryCreateInput.valid_date_to"
                        hide-header
                        show-adjacent-months
                        view-mode="month"
                        @update:model-value="onChangeValidDateTo"
                      ></v-date-picker>
                    </v-locale-provider>
                  </v-menu>
                </v-col>
              </v-row>
              <!-- 配達備考 -->
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-10" justify="end">
                    {{ wordList.lbl_delivery_notes }}
                    <v-tooltip location="top">
                      <template #activator="{ props }">
                        <v-icon v-bind="props">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>DSSでは注文備考に連携されます。</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_delivery_notes"
                    v-model="regularDeliveryCreateInput.delivery_notes"
                  >
                    <v-textarea
                      v-model="regularDeliveryCreateInput.delivery_notes"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :placeholder="wordList.plc_delivery_note"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-card-actions class="justify-center py-10 flex-wrap">
            <!-- 定期配送登録へ戻るボタン -->
            <v-btn
              v-if="!updateMode && !deleteMode"
              variant="flat"
              color="return"
              class="pa-5 px-16 my-2 mx-2 d-flex align-center"
              @click="onClickInputCancel"
            >
              <v-icon class="mr-2">mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
            <!-- 配送依頼一覧へ戻るボタン -->
            <v-btn
              v-if="updateMode || deleteMode"
              variant="flat"
              color="return"
              class="pa-5 px-16 my-2 mx-2 d-flex align-center"
              @click="onClickBack"
            >
              <v-icon class="mr-2">mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
            <!-- 確認画面へボタン -->
            <v-btn
              variant="flat"
              color="primary"
              class="px-16 my-2 mx-2"
              :disabled="!meta.valid"
              @click="onClickOpenConfirmDialog"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              <!-- 登録確認タイトル -->
              <span v-if="!updateMode && !deleteMode">
                {{ wordList.btn_regist_confirm }}
              </span>
              <!-- 変更確認タイトル -->
              <span v-else-if="updateMode">{{
                wordList.btn_edit_confirm
              }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </Form>
    </v-card>
    <!-- } 定期配送登録ダイアログ -->
    <!-- 定期配送登録確認ダイアログ { -->
    <v-card v-if="displayConfirmDialog" flat>
      <v-card flat>
        <!-- 登録確認タイトル -->
        <v-card-title
          v-if="!updateMode && !deleteMode"
          class="mt-3 text-h5 font-weight-bold"
        >
          {{ wordList.lbl_regular_delivery_regist_confirm }}
        </v-card-title>
        <!-- 変更確認タイトル -->
        <v-card-title
          v-else-if="updateMode"
          class="mb-3 text-h5 font-weight-bold"
        >
          {{ wordList.lbl_regular_delivery_edit_confirm }}
        </v-card-title>
        <!-- 削除確認タイトル -->
        <v-card-title v-else class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_regular_delivery_delete_confirm }}
        </v-card-title>
        <v-card-text style="min-height: 500px" class="pt-5 confirm-display-text">
          <!-- 配達元 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_source }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ shopData?.name ?? "" }}</v-col>
          </v-row>
          <!-- 配達先住所 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_destination_address }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.delivery_zip_code ? "〒" : "" }}
              {{ regularDeliveryCreateInput.delivery_zip_code.substring(0, 3) }}
              {{ regularDeliveryCreateInput.delivery_zip_code ? "-" : "" }}
              {{ regularDeliveryCreateInput.delivery_zip_code.substring(3) }}
              {{ regularDeliveryCreateInput.delivery_address1 }}
            </v-col>
          </v-row>
          <!-- 配達先住所(番地) -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_destination_address_detail }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">{{
                regularDeliveryCreateInput.delivery_address2
              }}</v-col>
          </v-row>
          <!-- 建物名 部屋番号 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_room_num }}
              </v-row>
            </v-col>
            <v-col cols="9">{{
                regularDeliveryCreateInput.delivery_address3
              }}</v-col>
          </v-row>
          <!-- お届け便選択 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_id }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              <span v-for="item in deliveryIdSelectValues" :key="item.label">
                {{ item.label }}
              </span>
              <span v-if="deliverySelectValues?.delivery_id === 99">
                {{ deliverySelectValues?.delivery_name }}
              </span>
              <span v-if="deliverySelectValues?.delivery_id !== 99">
                &nbsp;&nbsp;{{ deliverySelectValues?.delivery_name }}
              </span>
            </v-col>
          </v-row>
          <!-- 配達時間 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center"
                v-if="delivery_time_input"
                dense
                  class="py-2 pl-2"
                justify="end"
              >
                {{ wordList.lbl_delivery_time }}
                <ImportantChip></ImportantChip>
              </v-row>
              <v-row align="center"
                v-if="!delivery_time_input"
                dense
                  class="form-label-row mr-11 pl-2"
                justify="end"
              >
                {{ wordList.lbl_delivery_time }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.irregular_delivery_start_time }}
              ～
              {{ regularDeliveryCreateInput.irregular_delivery_end_time }}
            </v-col>
          </v-row>
          <!-- お名前(漢字) -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_name_kanji }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.delivery_name1 }}
              {{ regularDeliveryCreateInput.delivery_name2 }}
            </v-col>
          </v-row>
          <!-- お名前(かな) -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_name_kana }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.delivery_name_kana1 }}
              {{ regularDeliveryCreateInput.delivery_name_kana2 }}
            </v-col>
          </v-row>
          <!-- 電話番号 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_tel }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.delivery_phone }}
            </v-col>
          </v-row>
          <!-- 決済方法 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_pay_method }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.payment_method }}
            </v-col>
          </v-row>
          <!-- 支払金額 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_pay_money }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ dummy_payment_amount }}
              <span v-if="dummy_payment_amount">{{ wordList.lbl_yen }}</span>
            </v-col>
          </v-row>
          <!-- 個口数 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_unit_number }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.unit }}
            </v-col>
          </v-row>
          <!-- ハウスカード番号 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center"
                v-if="house_card_required == 1"
                dense
                  class="py-2 pl-2"
                justify="end"
              >
                {{ wordList.lbl_house_card }}
                <ImportantChip></ImportantChip>
              </v-row>
              <v-row align="center" v-else dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_house_card }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.house_card }}
            </v-col>
          </v-row>
          <!-- 会員備考 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_memo_member }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.member_notes }}
            </v-col>
          </v-row>
          <!-- 配達依頼作成日時 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_request_create }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ deliveryRequestCreateDateValues.label }}&nbsp;&nbsp;
              {{ deliveryRequestCreateTimeValues }}時
            </v-col>
          </v-row>
          <!-- 定期配達有効期間 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_valid_date }}
              </v-row>
            </v-col>
            <v-col
              v-if="
                (regularDeliveryCreateInput.valid_date_from !== undefined &&
                  regularDeliveryCreateInput.valid_date_from !== null &&
                  regularDeliveryCreateInput.valid_date_from !== '') ||
                (regularDeliveryCreateInput.valid_date_to !== undefined &&
                  regularDeliveryCreateInput.valid_date_to !== null &&
                  regularDeliveryCreateInput.valid_date_to !== '')
              "
              cols="9"
            >
              {{ regularDeliveryCreateInput.valid_date_from }} ～
              {{ regularDeliveryCreateInput.valid_date_to }}
            </v-col>
          </v-row>
          <!-- 配達備考 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_notes }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ regularDeliveryCreateInput.delivery_notes }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center flex-wrap">
          <!-- 戻るボタン -->
          <v-btn
            variant="flat"
            color="return"
            class="pa-5 px-16 my-2 mx-2 d-flex align-center"
            @click="onClickConfirmCancel"
          >
            <v-icon class="mr-2">mdi-arrow-left</v-icon>
            {{ wordList.btn_return }}
          </v-btn>
          <!-- 完了画面ボタン -->
          <v-btn
            v-if="!deleteMode"
            variant="flat"
            color="primary"
            class="px-16 my-2 mx-2"
            @click="onClickConfirmEntry"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            <!-- 登録完了ボタン -->
            <span v-if="!updateMode && !deleteMode">
              {{ wordList.btn_regist_complete }}
            </span>
            <!-- 変更完了ボタン -->
            <span v-else-if="updateMode">
              {{ wordList.btn_edit_complete }}
            </span>
          </v-btn>
          <!-- 削除完了ボタン -->
          <v-btn
            v-else
            variant="flat"
            color="primary"
            class="px-16 my-2 mx-2"
            @click="onClickDelete"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            <span>
              {{ wordList.btn_delete_complete }}
            </span>
          </v-btn>
        </v-card-actions>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-card>
    <!-- } 定期配送登録確認ダイアログ -->
    <!-- 定期配送登録完了ダイアログ { -->
    <v-card v-if="displayCompletedDialog" flat>
      <v-card flat>
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_regular_delivery_Request_regist_complete }}
        </v-card-title>
        <v-card-text style="min-height: 500px">
          <v-row class="pt-5">
            <v-col class="font-weight-black">
              {{ wordList.lbl_regular_delivery_Request_regist_complete_msg }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center flex-wrap">
          <!-- 戻るボタン -->
          <v-btn
            variant="flat"
            color="return"
            class="px-16 my-2 mx-2 d-flex align-center"
            @click="onClickCompletedGoStart"
          >
            <v-icon class="mr-2">mdi-arrow-left</v-icon>
            {{ wordList.btn_regist_return }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } 定期配送登録完了ダイアログ -->
    <!-- 住所選択共通ダイアログ -->
    <AddressSelectorDialog
      :address-dialog="addressDialog"
      :area-dialog="areaDialog"
      :toggle-mode="btnNonMemberToggle"
      :zip-code="zip_code"
      :pref="prefSelectValue"
      :pref-list-items="prefListItems ?? []"
      :selected-address="selectedAddressLabel"
      :original-city="originalCityAddress"
      :city-block-list="cityBlockList ?? null"
      :section-block-list="sectionBlockList ?? null"
      :block-list="addressDialogBlockList"
      :click-disabled="clickMode"
      :area-not-select-message="addressAreaNotSelectMessage"
      :errors="addressDialogErrors"
      :word-list="wordList"
      @update:address-dialog="onAddressDialogUpdate"
      @update:area-dialog="onAreaDialogUpdate"
      @update:zip-code="onZipCodeUpdate"
      @update:pref="onPrefUpdate"
      @toggle-zip="onClickToggleZip"
      @toggle-pref="onClickTogglePref"
      @zip-input="onZipCodeInput"
      @pref-input="onPrefSelectInput"
      @search="onClickAddressChangeBtn"
      @close-address="onCloseAddressDialog"
      @area-return="onClickAreaDialogReturn"
      @select-city="onClickCityBlockLink"
      @select-section="onClickSectionBlockLink"
      @select-block="onClickAddressBlockLink"
    />
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>


<script setup lang="ts">
import { computed } from "vue";
import { Form, Field } from "vee-validate";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import AddressSelectorDialog from "@/components/address-selector/AddressSelectorDialog.vue";
import type {
  AddressBlockItem as SharedAddressBlockItem,
  AddressSelectionErrors,
} from "@/components/address-selector/types";
import { ja as vuetifyJa } from "vuetify/locale";
import { useRegularDeliveryRegister } from "./composables/useRegularDeliveryRegister";

const {
  router,
  errdialog,
  errMessage,
  updateMode,
  deleteMode,
  areaDialog,
  overlay,
  wordList,
  wordListLoaded,
  dummy_payment_amount,
  displayConfirmDialog,
  displayCompletedDialog,
  memberCreateInput,
  memberUpdateInput,
  createMemberMutation,
  updateMemberMutation,
  zipAddressList,
  zipCodeFromPref,
  cityBlockList,
  originalAddress,
  originalSectionAddress,
  originalCityAddress,
  originalBlockName,
  sectionBlockList,
  blockList,
  addressBlockList,
  unassignedBlockList,
  areaNotSelectLabel,
  prefListItems,
  commmaMoney,
  removeComma,
  onFocus,
  onBlur,
  onChangeHouseCard,
  initialize,
  pref_name,
  zip_code,
  user_id,
  pref_name_befor,
  shopData,
  unitItems,
  paymentMethodItems,
  paymentRequiredFlg,
  btnNonMemberToggle,
  userErrorMessage,
  errorPrefSelect,
  memberData,
  deliveryAreaName,
  prefSelectValue,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  deliveryId_0_Flg,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  displayDeliveryTime,
  addressFixed,
  addressDialog,
  errorZipCode,
  house_card_display,
  house_card_validation,
  house_card_required,
  house_card_change,
  house_card_before,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  operationInput,
  areaListItems,
  deliveryIdSelectValues,
  listDeliveryTime,
  deliverySelectValues,
  deliveryRequestCreateDateItem,
  deliveryRequestCreateDateValues,
  deliveryRequestCreateTimeItem,
  deliveryRequestCreateTimeValues,
  listDeliveryId,
  deliveryIdItems,
  getRegularDelivery,
  initializeAddress,
  onClickAddressChangeBtn,
  onClickCityBlockLink,
  onClickSectionBlockLink,
  deliverySelectDayBox,
  deliverySelectBox,
  setDeliveryAreaSectionUnassigned,
  areaClear,
  areaAddresSelectClear,
  GetAreaData,
  regularDeliveryCreateInput,
  regularDeliveryUpdateInput,
  queryDeliverytime,
  onClickToggleZip,
  onClickTogglePref,
  onZipCodeInput,
  onPrefSelectInput,
  chkDeliveryId,
  SetdeliveryId,
  delivery_time_input,
  onChangeDeliveryIdSelect,
  onChangeDeliveryId,
  onChangeDeliveryStartTime,
  onChangeDeliveryEndTime,
  onChangeDeliveryRequestCreateDate,
  formatDateYmd,
  onChangeValidDateFrom,
  onChangeValidDateTo,
  onClickAddressUpdate,
  clickMode,
  onClickAddressBlockLink,
  onClickAreaDialogReturn,
  getAreaList,
  onChangePaymentMethod,
  onClickOpenConfirmDialog,
  onClickInputCancel,
  onClickBack,
  createRegularDeliveryMutation,
  updateRegularDeliveryMutation,
  deleteRegularDeliveryMutation,
  createDeliveryId,
  onClickConfirmEntry,
  onClickDelete,
  onClickConfirmCancel,
  createRegularDelivery,
  updateRegularDelivery,
  deleteRegularDelivery,
  copyCreateToUpdate,
  createMember,
  updateMember,
  onClickCompletedGoStart,
  allClear,
} = useRegularDeliveryRegister();

/** 住所選択ダイアログで表示する選択中住所。 */
const selectedAddressLabel = computed(() => {
  if (user_id.value.length <= 0 || pref_name.value.length > 0) {
    return `${pref_name.value}${originalCityAddress.value}${originalSectionAddress.value}`;
  }
  return originalAddress.value;
});

/** 共通ダイアログ向けに丁目候補を正規化する。 */
const addressDialogBlockList = computed<SharedAddressBlockItem[]>(() => {
  return (blockList.value ?? []).map((value) => ({
    name: value,
    enabled: !unassignedBlockList.value.includes(value),
  }));
});

/** 共通ダイアログ向けにエラーを集約する。 */
const addressDialogErrors = computed<AddressSelectionErrors>(() => {
  return {
    zip: errorZipCode.value,
    pref: errorPrefSelect.value,
    general: userErrorMessage.value,
  };
});

/** 配達対象外メッセージは対象丁目がある時のみ表示する。 */
const addressAreaNotSelectMessage = computed(() => {
  if (!unassignedBlockList.value || unassignedBlockList.value.length === 0) {
    return "";
  }
  return areaNotSelectLabel.value;
});

/** addressDialog の v-model 更新を反映する。 */
const onAddressDialogUpdate = (value: boolean): void => {
  addressDialog.value = value;
};

/** areaDialog の v-model 更新を反映する。 */
const onAreaDialogUpdate = (value: boolean): void => {
  areaDialog.value = value;
};

/** 郵便番号入力値の更新を反映する。 */
const onZipCodeUpdate = (value: string): void => {
  zip_code.value = value;
};

/** 都道府県入力値の更新を反映する。 */
const onPrefUpdate = (value: string): void => {
  prefSelectValue.value = value;
};

/** 住所ダイアログの戻る操作を処理する。 */
const onCloseAddressDialog = (): void => {
  addressDialog.value = false;
  pref_name.value = pref_name_befor.value;
};
</script>

<style scoped>
/* お届け便選択の曜日セレクトボックス: 全曜日選択時にinput要素が幅を取って二行になる不具合を防止 */
.delivery-week-select :deep(.v-field__input > input) {
  width: 0;
  min-width: 0;
  padding: 0;
  position: absolute;
}

/* 支払金額フィールドのバリデーションエラーメッセージを左寄せにする */
:deep(.text-right .v-messages) {
  text-align: left;
}
</style>
